import type { EmbedPodcastHighlightProps } from "./EmbedPodcastHighlight";

export default function integrityCheck(props: EmbedPodcastHighlightProps) {
    const messages = [];

    if (!props.embedUrl) {
        messages.push("No Embed Url");
    }

    return messages;
}
